import "./Channel.scss"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { Route, Redirect, Switch } from "react-router-dom"
import {
  TransitionRoute,
  Header,
  Scroll,
  TabBar,
  TabLink,
  Wrapper,
} from "../lib"
import Behavior from "./behavior/Behavior"
import Appearance from "./appearance/Appearance"
import AutoMessages from "./automessages/AutoMessages"
import Contacts from "./contacts/Contacts"
import Embed from "./embed/Embed"
import { channelStore } from "../app/stores"

class Channel extends Component {
  componentDidMount() {
    channelStore.listenToChannel(this.props.match.params.channelId)
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.channelId !== this.props.match.params.channelId
    ) {
      channelStore.listenToChannel(nextProps.match.params.channelId)
    }
  }

  componentWillUnmount() {
    channelStore.unlistenToChannel()
  }

  render() {
    const { match } = this.props
    const { channel } = channelStore
    return (
      <div className="Channel">
        <Header title={channel ? `# ${channel.name}` : "#"}>
          {channelStore.isArchived && (
            <h5 className="Channel_archived">This channel has been archived</h5>
          )}
          <TabBar>
            <TabLink to={`${match.url}/appearance`} label="Appearance" />
            <TabLink to={`${match.url}/behavior`} label="Behavior" />
            <TabLink to={`${match.url}/automessages`} label="Auto Messages" />
            <TabLink to={`${match.url}/contacts`} label="Contacts" />
            <TabLink to={`${match.url}/embed`} label="Embed" />
          </TabBar>
        </Header>
        {channel && (
          <Wrapper>
            <Switch>
              <TransitionRoute
                path={`${match.path}/appearance`}
                component={Appearance}
              />
              <TransitionRoute
                path={`${match.path}/behavior`}
                component={Behavior}
              />
              <TransitionRoute
                path={`${match.path}/automessages`}
                component={AutoMessages}
              />
              <TransitionRoute path={`${match.path}/embed`} component={Embed} />
              <TransitionRoute
                path={`${match.path}/contacts`}
                component={Contacts}
              />
              <Route
                path={match.path}
                exactly
                render={() => <Redirect to={`${match.url}/appearance`} />}
              />
            </Switch>
          </Wrapper>
        )}
      </div>
    )
  }
}

Channel.displayName = "Channel"

export default observer(Channel)



// WEBPACK FOOTER //
// ./src/channel/Channel.js